import React from 'react';
import { FaStar, FaRoute, FaClockRotateLeft } from 'react-icons/fa6';
import { IoTrophySharp } from 'react-icons/io5';
import { useMenus } from './MenusContext';
import { useLayout } from '../../Layout/LayoutContext';
import { IconButton } from '../styles';
import { StorageService } from '~/utils/classes/StorageService';

interface MenuButtonsProps {
  collapsed: boolean;
}

export const MenuButtons: React.FC<MenuButtonsProps> = ({ collapsed }) => {
  const { viewMode, setViewMode } = useMenus();
  const { setCollapsed, setSelectedModulo } = useLayout();
  const store = new StorageService();

  const handleMenuClick = (mode: any) => {
    // Se a sidebar estiver recolhida, expande
    if (collapsed) {
      setCollapsed(false);
      store.save('session', 'collapsed', false);
      setSelectedModulo(null);
      setViewMode(mode);
    }
    // Se clicar no menu já selecionado com sidebar aberta, fecha
    else if (viewMode === mode) {
      setViewMode('modules');
      setCollapsed(true);
      store.save('session', 'collapsed', true);
    }
    // Caso contrário, seleciona o menu
    else {
      setSelectedModulo(null);
      setViewMode(mode);
    }
  };

  return (
    <>
      <IconButton
        title="Mais Acessadas"
        selected={viewMode === 'most-accessed'}
        onClick={() => handleMenuClick('most-accessed')}
      >
        <IoTrophySharp size={18} />
        {!collapsed && 'Mais Acessadas'}
      </IconButton>

      <IconButton
        title="Recentes"
        selected={viewMode === 'recent'}
        onClick={() => handleMenuClick('recent')}
      >
        <FaClockRotateLeft size={18} />
        {!collapsed && 'Recentes'}
      </IconButton>

      <IconButton
        title="Favoritas"
        selected={viewMode === 'favorites'}
        onClick={() => handleMenuClick('favorites')}
      >
        <FaStar size={18} />
        {!collapsed && 'Favoritas'}
      </IconButton>

      <IconButton
        title="Trilhas"
        selected={viewMode === 'trails'}
        onClick={() => handleMenuClick('trails')}
      >
        <FaRoute size={18} />
        {!collapsed && 'Trilhas'}
      </IconButton>
    </>
  );
};
